module.exports = require("core-js/modules/es.date.to-string.js");